import clsx from "clsx";
import React from "react";
import { twMerge } from "tailwind-merge";
import { useSettings } from "../../../context/SettingsContext";

interface WidgetIconProps {
  isFlyoutOpen: boolean;
  toggleFlyout: () => void;
  size?: number;
}

const WidgetIcon: React.FC<WidgetIconProps> = ({
  isFlyoutOpen,
  toggleFlyout,
  size = 60,
}) => {
  const { widgetDataSettings: widgetData } = useSettings();

  const colors = widgetData?.settings?.appearance?.colors;
  const color = colors?.iconColor || "#00beff";
  const secondaryColor = colors?.iconGradientEnabled
    ? colors?.iconColorGradient
    : colors?.iconColor || "#4258db";
  const gradient = colors?.iconGradientEnabled || false;

  const secondaryUse = gradient ? secondaryColor : color;

  return (
    <div
      className={twMerge(
        clsx(
          !isFlyoutOpen ? "" : "hidden ",
          !isFlyoutOpen
            ? "transition-transform duration-300 hover:scale-110"
            : "",
          "right-0 bottom-4 text-white rounded-full p-4 cursor-pointer"
        )
      )}
      onClick={toggleFlyout}
    >
      <div
        style={{
          width: size + "px",
          height: size + "px",
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden",
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="184"
          height="184"
          viewBox="0 0 184 184"
          fill="none"
          className="__web-inspector-hide-shortcut__"
        >
          <path
            d="M91.86 183.55C41.28 183.55 0 142.55 0 92.3C0 41.11 40.66 -0.0199927 91.2401 7.29084e-06C143.15 7.29084e-06 183.48 40.92 183.38 93.44C183.28 142.59 141.7 183.53 91.86 183.55ZM91.86 174.55C102.737 174.559 113.51 172.426 123.563 168.272C133.616 164.118 142.752 158.024 150.45 150.339C158.148 142.654 164.257 133.528 168.428 123.482C172.599 113.436 174.751 102.667 174.76 91.79C174.769 80.9126 172.636 70.1399 168.482 60.087C164.328 50.0341 158.234 40.8978 150.549 33.1999C142.864 25.5019 133.738 19.393 123.692 15.2219C113.646 11.0508 102.877 8.89921 92 8.89002C45.63 8.89002 8.82002 45.67 8.90002 91.89C8.86543 102.782 10.99 113.573 15.1508 123.64C19.3117 133.706 25.4263 142.848 33.1414 150.537C40.8565 158.226 50.019 164.31 60.0993 168.437C70.1796 172.563 80.9779 174.651 91.8701 174.58L91.86 174.55Z"
            fill="url(#paint0_linear_231_3873)"
          />
          <circle
            cx="92.5"
            cy="92.5"
            r="76.5"
            fill="url(#paint1_linear_231_3873)"
          />
          <g clipPath="url(#clip0_231_3873)">
            <path
              d="M91.7439 111.857C89.634 117.018 87.6116 121.993 85.5674 126.969C83.6228 131.721 81.6976 136.481 79.7336 141.223C77.9276 145.584 73.3748 147.543 69.1696 145.841C65.0373 144.155 63.1389 139.568 64.8307 135.241C69.014 124.546 73.263 113.88 77.3758 103.155C78.0248 101.454 78.2265 99.5601 78.4089 97.7321C78.579 96.0476 78.4648 94.3291 78.438 92.6276C78.4113 90.9261 77.4657 89.9538 75.7642 89.7933C68.4282 89.1354 61.0922 88.4751 53.7562 87.8123C49.3809 87.4112 46.3522 84.4092 46.0362 80.1651C45.7518 76.361 48.4475 72.5399 52.3221 71.9614C54.6751 71.6114 57.1593 71.9444 59.5657 72.1583C72.6699 73.325 85.7546 74.871 98.9438 74.2754C103.672 74.0615 108.382 73.5195 113.1 73.1233C118.626 72.659 124.143 72.044 129.678 71.7742C133.837 71.5725 137.25 74.9512 137.578 79.1175C137.906 83.2838 135.011 87.0369 130.915 87.6397C128.677 87.9703 126.409 88.1258 124.153 88.3227C118.672 88.8235 113.188 89.295 107.707 89.8128C106.212 89.9513 105.276 90.9577 105.249 92.4623C105.22 94.65 105.108 96.8376 105.29 99.0253C105.446 100.509 105.81 101.963 106.372 103.345C110.504 114.013 114.71 124.655 118.871 135.314C120.269 138.892 119.148 142.681 116.127 144.816C112.991 147.03 108.878 146.887 106.068 144.257C105.092 143.296 104.324 142.145 103.81 140.875C99.8796 131.52 96.0317 122.13 92.1596 112.749C92.055 112.526 91.9481 112.309 91.7439 111.857ZM54.4271 77.1899C52.9687 77.134 51.7533 78.082 51.5953 79.5356C51.4519 80.9357 52.5214 82.1097 54.2132 82.275C61.7048 83.0043 69.1988 83.6776 76.6903 84.3946C78.6467 84.5726 80.4663 85.4739 81.7934 86.9223C83.1204 88.3707 83.8594 90.2621 83.8659 92.2265C83.8877 94.2513 84.0263 96.2931 83.827 98.3034C83.6564 100.428 83.2546 102.528 82.6286 104.565C81.5615 107.82 80.1809 110.98 78.9242 114.181C75.91 121.857 72.8935 129.533 69.8745 137.207C69.2692 138.749 69.7846 140.161 71.1677 140.768C72.5507 141.376 73.9193 140.768 74.612 139.22C74.7627 138.89 74.9013 138.552 75.0398 138.216C78.9387 128.759 82.8352 119.3 86.7293 109.84C87.3856 108.243 88.4478 107.108 90.0886 106.57C92.9496 105.637 95.6793 107.039 96.919 110.032C100.889 119.68 104.859 129.326 108.83 138.97C109.559 140.708 110.898 141.4 112.359 140.793C113.82 140.185 114.326 138.707 113.667 137.028C111.074 130.401 108.476 123.778 105.874 117.156C104.234 112.977 102.591 108.8 100.944 104.626C99.1237 100.007 99.532 95.1993 100.021 90.4739C100.351 87.2726 103.475 84.7544 106.659 84.4457C112.055 83.9255 117.461 83.4734 122.86 82.9702C125.198 82.7563 127.539 82.5643 129.868 82.2799C130.522 82.2136 131.123 81.8904 131.539 81.3814C131.955 80.8723 132.152 80.219 132.087 79.5648C132.049 78.8901 131.747 78.2574 131.247 77.8028C130.747 77.3482 130.088 77.1081 129.413 77.134C129.049 77.134 128.684 77.1632 128.322 77.1972C120.986 77.8511 113.642 78.4515 106.314 79.1807C94.9014 80.3183 83.5207 79.9269 72.1351 78.7723C66.3037 78.1695 60.4529 77.7198 54.4271 77.1899Z"
              fill="white"
            />
            <path
              d="M91.8333 37C93.9431 36.9965 96.033 37.4087 97.9834 38.2132C99.9339 39.0176 101.707 40.1985 103.201 41.6884C104.695 43.1782 105.88 44.9478 106.69 46.8961C107.5 48.8444 107.918 50.9331 107.92 53.0429C107.92 61.9249 100.667 69.132 91.7142 69.1248C89.6045 69.1191 87.5168 68.6965 85.571 67.8814C83.6252 67.0663 81.8597 65.8747 80.3759 64.375C78.892 62.8754 77.7192 61.0973 76.9248 59.143C76.1303 57.1887 75.7299 55.0966 75.7466 52.987C75.7709 44.054 82.8711 37 91.8333 37ZM81.1963 53.0284C81.1769 55.8536 82.28 58.571 84.2631 60.5833C86.2463 62.5956 88.9473 63.7383 91.7725 63.7601C97.6063 63.7868 102.439 58.9448 102.443 53.094C102.448 51.699 102.177 50.3169 101.647 49.0265C101.118 47.7361 100.339 46.5627 99.3555 45.5732C97.3695 43.575 94.6712 42.4475 91.8539 42.4388C89.0367 42.4301 86.3314 43.5409 84.3332 45.5268C82.3349 47.5127 81.2075 50.2111 81.1988 53.0284H81.1963Z"
              fill="white"
            />
          </g>
          <defs>
            <linearGradient
              id="paint0_linear_231_3873"
              x1="91.6901"
              y1="0"
              x2="91.6901"
              y2="183.55"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor={color} />
              <stop offset="1" stopColor={secondaryUse} />
            </linearGradient>
            <linearGradient
              id="paint1_linear_231_3873"
              x1="92.5"
              y1="16"
              x2="92.5"
              y2="169"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor={color} />
              <stop offset="1" stopColor={secondaryUse} />
            </linearGradient>
            <clipPath id="clip0_231_3873">
              <rect
                width="91.588"
                height="109.452"
                fill="white"
                transform="translate(46 37)"
              />
            </clipPath>
          </defs>
        </svg>
      </div>
    </div>
  );
};

export default WidgetIcon;
